export default __webpack_public_path__ + "static/media/yuryu-08.d7751a05.svg";